module.exports = __webpack_public_path__ + "static/img/derby-robert.9e5a0e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/derby-robert.jpg
// module id = mvkm
// module chunks = 0